import { useEffect, useState } from 'react';

interface usePersistedStateProps<S> {
    initialState: S;
    key: string;
}
export function usePersistedState<S>(props: usePersistedStateProps<S>) {
    const item = localStorage.getItem(props.key);

    const [state, setState] = useState<S>(item ? JSON.parse(item) : props.initialState);

    useEffect(() => {
        localStorage.setItem(props.key, JSON.stringify(state));
    }, [state]);

    return [state, setState] as [S, React.Dispatch<React.SetStateAction<S>>];
}

export const useExperimentalPersistedState = <S>(props: usePersistedStateProps<S>) => {
    const item = localStorage.getItem(props.key);

    const [state, setState] = useState<S>(
        item
            ? props.initialState
                ? Array.isArray(props.initialState)
                    ? [...props.initialState, ...JSON.parse(item)]
                    : { ...props.initialState, ...JSON.parse(item) }
                : props.initialState
            : props.initialState
    );

    useEffect(() => {
        localStorage.setItem(props.key, JSON.stringify(state));
    }, [state]);

    return [state, setState] as [S, React.Dispatch<React.SetStateAction<S>>];
};
